import { Node_Type } from 'wix-rich-content-common';
import { Node_Type as Node_Type$1 } from 'ricos-types';
import React, { useRef, useContext } from 'react';
import { RicosNodeContextProvider, RicosNodeContext } from 'ricos-context';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const DEFAULTS = Object.freeze({});

const TABLE_TYPE = "wix-rich-content-plugin-table";
({
  insert: `${Node_Type.TABLE}.insert`
});

var styles$2 = {"viewMode":"jmReO","editMode":"uBxAo","container":"o5QJN","cell":"Z-Gkn"};

const CELL_AUTO_MIN_WIDTH = 120;
({
  FORMATTING: `${Node_Type.TABLE}.formatting`,
  VERTICAL_ALIGNMENT: `${Node_Type.TABLE}.verticalAlignment`,
  BACKGROUND_COLOR: `${Node_Type.TABLE}.backgroundColor`,
  ROW_HEADER: `${Node_Type.TABLE}.rowHeader`,
  COLUMN_HEADER: `${Node_Type.TABLE}.columnHeader`,
  BORDER: `${Node_Type.TABLE}.border`,
  CONTEXT: `${Node_Type.TABLE}.contextMenu`
});
({
  BORDER: `${Node_Type.TABLE}.border`,
  VERTICAL_ALIGNMENT: `${Node_Type.TABLE}.verticalAlignment`,
  CONTEXT: `${Node_Type.TABLE}.contextMenu`
});

const ROOT = "TableComponent";

var __defProp$3 = Object.defineProperty;
var __getOwnPropSymbols$3 = Object.getOwnPropertySymbols;
var __hasOwnProp$3 = Object.prototype.hasOwnProperty;
var __propIsEnum$3 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$3 = (obj, key, value) => key in obj ? __defProp$3(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$3 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$3.call(b, prop))
      __defNormalProp$3(a, prop, b[prop]);
  if (__getOwnPropSymbols$3)
    for (var prop of __getOwnPropSymbols$3(b)) {
      if (__propIsEnum$3.call(b, prop))
        __defNormalProp$3(a, prop, b[prop]);
    }
  return a;
};
var __objRest$2 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$3.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$3)
    for (var prop of __getOwnPropSymbols$3(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$3.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
function normalizeColumnWidths(colsMinWidths, colsRelativeWidths) {
  const colsWithDefaults = colsRelativeWidths.map((originalWidth, i) => {
    const minWidth = colsMinWidths[i] || CELL_AUTO_MIN_WIDTH;
    const width = originalWidth < minWidth ? minWidth : originalWidth;
    return {
      width,
      minWidth
    };
  });
  const ratios = colsWithDefaults.map((c) => c.width / c.minWidth);
  const smallestRatio = Math.min(...ratios);
  return colsWithDefaults.map(({ minWidth, width }) => ({
    minWidth,
    width: width / smallestRatio
  }));
}
const Table = ({
  node,
  nodeIndex,
  RicosNodesRenderer,
  NodeViewContainer
}) => {
  const tableRef = useRef(null);
  const { dimensions: { colsMinWidth = [], colsWidthRatio = [] } = {} } = node.tableData || {};
  const colStyles = normalizeColumnWidths(colsMinWidth, colsWidthRatio);
  return /* @__PURE__ */ React.createElement(NodeViewContainer, { node, nodeIndex, withHorizontalScroll: true }, /* @__PURE__ */ React.createElement("div", { ref: tableRef, className: styles$2.viewMode }, /* @__PURE__ */ React.createElement("table", { className: styles$2.container, "data-hook": ROOT }, /* @__PURE__ */ React.createElement("colgroup", null, colStyles.map((colStyle, index) => {
    return /* @__PURE__ */ React.createElement("col", { key: index, style: colStyle });
  })), /* @__PURE__ */ React.createElement("tbody", null, /* @__PURE__ */ React.createElement(RicosNodeContextProvider, { parentNode: node, parentIndex: nodeIndex }, /* @__PURE__ */ React.createElement(RicosNodesRenderer, { nodes: node.nodes }))))));
};
const TableRenderer = (_a) => {
  var _b = _a, { node } = _b, props = __objRest$2(_b, ["node"]);
  return /* @__PURE__ */ React.createElement(Table, __spreadValues$3({ key: node.id, node }, props));
};

var __defProp$2 = Object.defineProperty;
var __getOwnPropSymbols$2 = Object.getOwnPropertySymbols;
var __hasOwnProp$2 = Object.prototype.hasOwnProperty;
var __propIsEnum$2 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$2 = (obj, key, value) => key in obj ? __defProp$2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$2 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$2.call(b, prop))
      __defNormalProp$2(a, prop, b[prop]);
  if (__getOwnPropSymbols$2)
    for (var prop of __getOwnPropSymbols$2(b)) {
      if (__propIsEnum$2.call(b, prop))
        __defNormalProp$2(a, prop, b[prop]);
    }
  return a;
};
var __objRest$1 = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$2.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$2)
    for (var prop of __getOwnPropSymbols$2(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$2.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const TableRow = ({ node, nodeIndex, RicosNodesRenderer }) => {
  var _a, _b, _c;
  const { parentNode } = useContext(RicosNodeContext);
  const style = { height: ((_c = (_b = (_a = parentNode == null ? void 0 : parentNode.tableData) == null ? void 0 : _a.dimensions) == null ? void 0 : _b.rowsHeight) == null ? void 0 : _c[nodeIndex]) || "auto" };
  return /* @__PURE__ */ React.createElement("tr", { style }, /* @__PURE__ */ React.createElement(RicosNodeContextProvider, { parentNode, parentIndex: nodeIndex }, /* @__PURE__ */ React.createElement(RicosNodesRenderer, { nodes: node.nodes })));
};
const TableRowRenderer = (_a) => {
  var _b = _a, { node } = _b, props = __objRest$1(_b, ["node"]);
  return /* @__PURE__ */ React.createElement(TableRow, __spreadValues$2({ key: node.id, node }, props));
};

var styles$1 = {"cell":"zt3VC","header":"GHTu5","selected":"_0-CKq","editing":"_4XTVP","singleSelection":"lipt2","hideLastBlock":"yvj1n","editorWrapper":"FKQyj","viewerWrapper":"_8PwO5","hideFirstBlock":"l-r7L","editor":"FEDDP","edit":"_5sWzG","view":"UocxR","editingToolbarWrapper":"v0nsq","selectAll":"yUD4L","disableSelection":"x-lwW"};

var styles = {"borderT":"p36PG","borderB":"TARHz","borderL":"xA8W3","borderR":"GP7pt"};

const CellBorders = ({ borders }) => [
  (borders == null ? void 0 : borders.top) && /* @__PURE__ */ React.createElement("div", { key: "top", style: { background: borders.top }, className: styles.borderT }),
  (borders == null ? void 0 : borders.bottom) && /* @__PURE__ */ React.createElement("div", { key: "bottom", style: { background: borders.bottom }, className: styles.borderB }),
  (borders == null ? void 0 : borders.right) && /* @__PURE__ */ React.createElement("div", { key: "right", style: { background: borders.right }, className: styles.borderR }),
  (borders == null ? void 0 : borders.left) && /* @__PURE__ */ React.createElement("div", { key: "left", style: { background: borders.left }, className: styles.borderL })
];
CellBorders.propTypes = {
  borders: PropTypes.object
};

var __defProp$1 = Object.defineProperty;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = (obj, key, value) => key in obj ? __defProp$1(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues$1 = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp$1.call(b, prop))
      __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(b)) {
      if (__propIsEnum$1.call(b, prop))
        __defNormalProp$1(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp$1.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1)
    for (var prop of __getOwnPropSymbols$1(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const TableCell = ({ node, nodeIndex, RicosNodesRenderer }) => {
  var _a, _b;
  const { parentNode, parentIndex } = useContext(RicosNodeContext);
  const { borderColors, cellStyle } = (node == null ? void 0 : node.tableCellData) || {};
  const isHeaderCell = parentIndex === 0 && ((_a = parentNode == null ? void 0 : parentNode.tableData) == null ? void 0 : _a.rowHeader) || nodeIndex === 0 && ((_b = parentNode == null ? void 0 : parentNode.tableData) == null ? void 0 : _b.columnHeader);
  const Tag = isHeaderCell ? "th" : "td";
  const style = {};
  (cellStyle == null ? void 0 : cellStyle.backgroundColor) && (style.backgroundColor = cellStyle.backgroundColor);
  (cellStyle == null ? void 0 : cellStyle.verticalAlignment) && (style.verticalAlign = cellStyle.verticalAlignment.toLowerCase());
  return /* @__PURE__ */ React.createElement(
    Tag,
    {
      "data-hook": "table-plugin-cell",
      className: classNames(styles$1.cell, isHeaderCell && styles$1.header),
      style
    },
    /* @__PURE__ */ React.createElement("div", { className: classNames(styles$1.editor, styles$1.view) }, /* @__PURE__ */ React.createElement(RicosNodeContextProvider, { parentNode, parentIndex: nodeIndex }, /* @__PURE__ */ React.createElement(RicosNodesRenderer, { nodes: node.nodes, shouldParagraphApplyTextStyle: true }))),
    CellBorders({ borders: borderColors })
  );
};
const TableCellRenderer = (_a) => {
  var _b = _a, { node } = _b, props = __objRest(_b, ["node"]);
  return /* @__PURE__ */ React.createElement(TableCell, __spreadValues$1({ key: node.id, node }, props));
};

const nodeViewRenderers = {
  [Node_Type$1.TABLE]: TableRenderer,
  [Node_Type$1.TABLE_ROW]: TableRowRenderer,
  [Node_Type$1.TABLE_CELL]: TableCellRenderer
};

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const pluginTable = (config) => {
  return {
    config: __spreadValues(__spreadValues({}, DEFAULTS.config), config),
    type: TABLE_TYPE,
    nodeViewRenderers
  };
};

export { TABLE_TYPE, pluginTable };
//# sourceMappingURL=viewer.js.map

import 'wix-rich-content-plugin-table/dist/es/styles.viewer.min.global.css'